import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const plansTableTooltips = TOOLTIPS_TEXTS.plansTable;

const elevationsTableTooltips = TOOLTIPS_TEXTS.elevationsTable;

export const PLANS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const PLANS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const ELEVATIONS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'download', src: 'icons/download-green' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const ELEVATIONS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const PLANS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'divisions', 'assignedCommunities', 'elevationsCount', 'options'],
  displayedTitles: ['Name', 'Division(s)', 'Assigned Communities', '# of Elevations', 'Actions'],
  columnsConfig: [
    { sorting: true },
    { sorting: false },
    { sorting: false },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    plansTableTooltips.name,
    plansTableTooltips.divisions,
    plansTableTooltips.communities,
    plansTableTooltips.elevationsCount
  ],
  options: null,
  dataSource: []
};

export const ELEVATIONS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['checkbox', 'index', 'name', 'image', 'options'],
  displayedTitles: ['All', 'Order', 'Name', 'Thumbnail', 'Actions'],
  columnsConfig: [
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false }
  ],
  displayedTooltips: ['', elevationsTableTooltips.order, elevationsTableTooltips.name, null],
  options: null,
  dataSource: []
};

export const ELEVATIONS_ARCHIVED_TABLE_CONFIG: TableSource = {
  displayedColumns: ['checkbox', 'name', 'image', 'options'],
  displayedTitles: ['All', 'Name', 'Thumbnail', 'Actions'],
  columnsConfig: [{ sorting: false }, { sorting: false }, { sorting: false }, { sorting: false }],
  displayedTooltips: ['', elevationsTableTooltips.name, ''],
  options: null,
  dataSource: []
};
